var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.workspaceInvitationModel
    ? _c("div", { staticClass: "container" }, [
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "jumbotron" }, [
          _c("h1", { staticClass: "display-4" }, [
            _vm._v("Invitation to workspace " + _vm._s(_vm.workspaceName)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "lead" }, [
            _vm._v("You were invited to workspace "),
            _c("strong", [_vm._v(_vm._s(_vm.workspaceName))]),
            _vm._v(" owned by "),
            _c("strong", [_vm._v(_vm._s(_vm.organizationName))]),
            _vm._v(" in TransparentChoice application"),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success text-white",
              staticStyle: { padding: "0.7em 2em" },
              on: { click: _vm.handleAcceptWorkspaceInvitationCommandV1 },
            },
            [
              _c("i", {
                staticClass: "fa fa-check",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Accept invitation")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary text-white",
              staticStyle: { padding: "0.7em 2em" },
              on: { click: _vm.handleRejectWorkspaceInvitationCommandV1 },
            },
            [
              _c("i", {
                staticClass: "fa fa-ban",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Reject invitation")]),
            ]
          ),
        ]),
      ])
    : _c("div", [_c("h4", [_vm._v("Loading...")])])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }